export default __webpack_public_path__ + "static/media/logo-jeanie.6ec4f246.svg";